// localhost
//export const url = 'http://192.168.1.32:8000';

// aws cloud
//export const url = 'http://detection-suit-cloud-server.ap-southeast-2.elasticbeanstalk.com';

export const url = 'https://aolhmserver.com';